module.exports = __webpack_public_path__ + "img/praetorium_tech_Normal_ua.4ca92592.webp";